__turbopack_context__.v({
  "deliveryColorIndicator": "DeliveryColorIndicator-module__7eG-8W__deliveryColorIndicator",
  "deliveryColorIndicator__blue": "DeliveryColorIndicator-module__7eG-8W__deliveryColorIndicator__blue",
  "deliveryColorIndicator__brown": "DeliveryColorIndicator-module__7eG-8W__deliveryColorIndicator__brown",
  "deliveryColorIndicator__green": "DeliveryColorIndicator-module__7eG-8W__deliveryColorIndicator__green",
  "deliveryColorIndicator__purple": "DeliveryColorIndicator-module__7eG-8W__deliveryColorIndicator__purple",
});
